export default __webpack_public_path__ + "static/media/info.fccead0d.svg";